import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {ITournamentsStore} from "data/stores/tournaments/tournaments.store";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import {IExpertTeam} from "data/providers/json/json.provider";

export interface IExpertTeamsController extends ViewController {
	readonly i18n: ILocalizationStore;

	get expertTeams(): IExpertTeam[];
}

@injectable()
export class ExpertTeamsController implements IExpertTeamsController {
	get expertTeams() {
		return this._tournamentsStore.expertTeams;
	}

	constructor(
		@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore,
		@inject(Bindings.TournamentsStore) public _tournamentsStore: ITournamentsStore
	) {
		makeAutoObservable(this);
	}
}
